(function () {
  class FreespinsFireSlot extends PIXI.Container {
    constructor() {
      super();

      this._state = 0;
      this._flashSurround = false;
      this._flashSurroundIn = false;

      messageBus.subscribe(
        "spinner:GameConfigEvent",
        this.onGameConfigEvent.bind(this)
      );
    }

    findChild(parent, name) {
      const child = parent.find(function (child) {
        return child.Props.ID === name;
      });
      return child;
    }

    onGameConfigEvent() {
      this._activeSurround = this.findChild(
        this.children[0].children,
        "activeSurround"
      );
      this._activeSurround.visible = false;
      this._activeSurround.alpha = 0;

      this._activeSurroundGlow = this.findChild(
        this.children[0].children,
        "activeSurroundGlow"
      );
      this._activeSurroundGlow.visible = false;
      this._activeSurroundGlow.alpha = 0;

      this._lock = this.findChild(this.children[0].children, "lock");
      this._lock.visible = false;

      this._lockGlow = this.findChild(this.children[0].children, "lockGlow");
      this._lockGlow.visible = false;
    }

    activationChange(state, callback) {
      switch (state) {
        case 0: {
          this.demote(callback);
          break;
        }
        case 1: {
          this.demote(callback);
        }
        case 2: {
          this.activate(callback);
          break;
        }
        case 3: {
          this.lock(callback);
          break;
        }
      }
      this._state = state;
    }

    activate(callback) {
      switch (this._state) {
        case 0: {
          this.stopFlashSurround();

          this._activeSurround.visible = true;
          this._activeSurroundGlow.visible = true;

          this._activeSurround.alpha = 0;
          this._activeSurroundGlow.alpha = 0;

          gsap.to(this._activeSurround, {
            duration: 0.3,
            alpha: 1,
            onComplete: () => {
              callback();
            },
          });

          gsap
            .timeline()
            .to(this._activeSurroundGlow, {
              duration: 0.3,
              alpha: 1,
            })
            .to(this._activeSurroundGlow, {
              duration: 0.8,
              alpha: 0,
              onComplete: () => {
                this._activeSurroundGlow.visible = false;
              },
            });
          break;
        }
        case 1: {
          gsap
            .timeline()
            .to(this._activeSurroundGlow, {
              duration: 0.3,
              alpha: 1,
            })
            .to(this._activeSurroundGlow, {
              duration: 0.8,
              alpha: 0,
              onComplete: () => {
                this._activeSurroundGlow.visible = false;
              },
            });

          this.stopFlashSurround();
          this._activeSurround.visible = true;
          callback();
          break;
        }
      }
    }

    demote(callback) {
      switch (this._state) {
        case 1: {
          this.dropSurroundOff(callback);
          break;
        }
        case 2: {
          this.startFlashSurround();
          timerManager.addTimeout(500, function () {
            callback();
          });
          break;
        }
        case 3: {
          console.log("Error");
        }
      }
    }

    startFlashSurround() {
      this._flashSurround = true;
      this._flashSurroundIn = false;
      this.flashSurround();
      if (this._state === 3) {
        console.log("Error");
      }
    }

    flashSurround() {
      const self = this;
      this._flashSurroundTimer = timerManager.addTimer(
        1000,
        function (progress) {
          if (self._flashSurroundIn) {
            self._activeSurround.alpha = progress;
          } else {
            self._activeSurround.alpha = 1 - progress;
          }
        },
        function () {
          if (self._flashSurroundIn) {
            self._activeSurround.alpha = 1;
          } else {
            self._activeSurround.alpha = 0;
          }
          self._flashSurroundIn = !self._flashSurroundIn;
          self.flashSurround();
        }
      );
    }

    stopFlashSurround() {
      this._flashSurround = false;
      timerManager.stop(this._flashSurroundTimer);
      this._activeSurround.alpha = 1;
    }

    easeInCubic(x) {
      return x * x * x;
    }

    dropSurroundOff(callback) {
      this._activeSurround.visible = true;

      this.stopFlashSurround();

      soundManager.play("removeFrame");

      const distanceToDrop = 400;
      const self = this;

      timerManager.addTimer(
        1000,
        function (progress) {
          const prog = self.easeInCubic(progress);
          const startY = layoutController.getCurrentPosition(
            self._activeSurround.Props.FQN
          ).y;
          const endY = startY + distanceToDrop;
          const distance = (endY - startY) * prog;
          self._activeSurround.position.setY(startY + distance);
          self._activeSurround.alpha = 1 - progress;
        },
        function () {
          const startY = layoutController.getCurrentPosition(
            self._activeSurround.Props.FQN
          ).y;
          self._activeSurround.position.setY(startY);
          self._activeSurround.alpha = 1;
          self._activeSurround.visible = false;
          callback();
        }
      );
    }

    lock(callback) {
      this.stopFlashSurround();
      const self = this;

      gsap.to(this._activeSurround.scale, {
        duration: 0.25,
        x: 1.1,
        y: 1.1,
        repeat: 1,
        yoyo: true,
      });

      soundManager.play("addLock");

      this._lockGlow.visible = true;
      this._lock.visible = true;

      this._lock.alpha = 0;
      this._lockGlow.alpha = 0;

      this._lock.scale.set(2, 2);

      gsap
        .timeline({ delay: 0.25 })
        .to(this._lock, {
          duration: 0.5,
          alpha: 1,
          pixi: { scaleX: 1, scaleY: 1 },
          ease: "power1.out",
        })
        .to(this._lockGlow, {
          duration: 0.5,
          alpha: 1,
        })
        .to(this._lockGlow, {
          duration: 0.8,
          alpha: 0,
          onComplete: () => {
            this._lockGlow.visible = false;
            callback();
          },
        });
    }

    removeSurround() {
      this.stopFlashSurround();
      this._activeSurround.visible = false;
      this._lock.visible = false;
    }

    reset() {
      this._state = 0;
      this.stopFlashSurround();
      this._activeSurround.visible = false;
      this._lock.visible = false;
    }
  }

  var creator = function (json) {
    return new FreespinsFireSlot();
  };

  var initialiser = function (json, freespinsFireSlot) {};

  var filesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "freespinsFireSlot",
    creator,
    initialiser,
    filesRequired
  );
})();
